import * as types from '@/store/types';
import axios from 'axios';

export default {
  saveToken({ commit }, token) {
    commit(types.SAVE_TOKEN, token);
  },
  async saveStory({}, { stories }) {
    try {
      await axios.post('/api/web/stories', stories);
      return true;
    } catch (error) {
      return error;
    }
  },
  async getStories({ commit }, payload) {
    try {
      const { data } = await axios.get(
        `/api/web/stories?page=${payload.page}&filter=${payload.filter}`
      );
      commit(types.FECTH_STORIES, { stories: data });
      return data;
    } catch (e) {
      return null;
    }
  },
  async getStory({ commit }, id) {
    try {
      const data = await axios.get(`/api/web/stories/${id}`);
      commit(types.FECTH_STORY, { story: { data } });
      return data;
    } catch (e) {
      return null;
    }
  }
};
